import ApiResourceManager from '../ApiResourceManager';

export default class GiftCardManager extends ApiResourceManager {
  get = (params) =>
    this.request({
      method: 'GET',
      url: 'gift-cards',
      params,
    });

  create = (data) =>
    this.request({
      method: 'POST',
      url: 'gift-cards',
      data,
    });

  redeem = (data) =>
    this.request({
      method: 'POST',
      url: 'gift-cards/redeem',
      data,
    });

  checkBalance = (data) =>
    this.request({
      method: 'POST',
      url: 'gift-cards/check-balance',
      data,
    });
}
